import ServiceIcon from "../../components/ui/ServiceIcon";
import styles from "./WhyICS.module.css"
import { useAppContext } from "../../AppContext";
import data from "data/heroTableData.json"

export default function WhyICS() {
    const { isMobile } = useAppContext();

    const desktopTable = () => (
        <table border="1" className={styles["ics-table"]}>
                <caption className={styles["ics-table-caption"]}>Why Our Automated & AI-Powered Solutions Are Better</caption>
                <thead>
                    <tr className={styles["ics-table-header"]}>
                        <th scope="col"></th>
                        <th className={styles["ics-col-head"]} scope="col">iCredentialing Solutions</th>
                        <th scope="col">Manual Credentialing</th>
                        <th scope="col">No Credentialing at All</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((ele) => {
                        return(
                            <tr key={ele.category}>
                                <td className={styles["table-row-name"]}>
                                    <span className={styles["table-row-icon"]}>
                                        <ServiceIcon type={ele.icon} size={24} />
                                    </span>
                                    {ele.category}
                                </td>
                                <td className={styles["ics-col"]}>{ele.ics}</td>
                                <td>{ele.manual}</td>
                                <td>{ele.none}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
    )

    const mobileTable = () => (
        <>
            {data.map((ele) => (
                <table key={ele.category} border="1" className={styles["ics-table"]}>
                    <caption className={styles["ics-table-caption"]}>
                        <span className={styles["caption-icon"]}><ServiceIcon type={ele.icon}/></span>
                        <span>{ele.category}</span>
                    </caption>
                    <thead>
                        <tr className={styles["ics-table-header"]}>
                            <th className={styles["ics-col-head"]} scope="col"><p>iCredentialing Solutions</p></th>
                            <th scope="col"><p>Manual Credentialing</p></th>
                            <th scope="col"><p>No Credentialing</p></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className={styles["ics-col"]}><p>{ele.ics}</p></td>
                            <td><p>{ele.manual}</p></td>
                            <td><p>{ele.none}</p></td>
                        </tr>
                    </tbody>
                </table>
            ))}
        </>
    )

    return (
        <main className={styles["ics-table-container"]}>
            {isMobile ? mobileTable() : desktopTable()}
        </main>
    );
}

